import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  public barChartOptions= {
    scaleShowVerticalLines:false,
    responsive:true
  };

  public barChartLabels = ['2006', '2007', '2008','2009', '2010','2011','2012'];
  public barChartType = "bar";
  public barChartLegend = true;

  public barChartData = [
    {data:[65, 59, 10, 49, 50, 58, 22], 
      label: 'series A', 
      backgroundColor:'#FF6F3C',
      pointBackgroundColor:'#FF6F3C',
      pointHoverBackgroundColor:'#FF6F3C'
    },
    {data:[99, 59, 88, 34, 78, 57, 44], label: 'serial B', backgroundColor:'#3f51b5',pointHoverBackgroundColor:'#3f51b5'}
  ];
  constructor() { 
  }
  ngOnInit() {
    
  }
}
